<template>
<div>
  <div class="form-group">
    <label for="collection"><strong>COLLEZIONE</strong></label>    

    <div class="input-group">

      <div  v-if="binocular" class="input-group-prepend">
        <button title="Lista documenti collezione" type="button" @click="$emit('getDocuments')" :disabled="collectionId==0" class="input-group-text" id="basic-addon1">
          <i class='fas fa-binoculars'></i>
        </button>
      </div>

    <select id="collection_select" :required="props.required" :disabled="!props.isActive" @change="$emit('update',collectionId,$event)" class="form-control" v-model="collectionId" >      
      <option  v-for="(item,index) in items" :value="item.collectionId" :key="index">
                
        {{item.description}} </option>        
    </select>
      </div>
  </div>  
</div>
</template>
<script>
import api from '@/api'

import { mapGetters }    from 'vuex';

export default {
  props : ['props','binocular'] , 
  components: {},
  data() {
    return {

      collectionId           : 0,
      items                  : [],
      spinner                : false,
      

   
    };
  },
  computed :{
    ...mapGetters(['company']),
   
  },
  mounted: function() {
     
  },
  created: function() {
     // this.storeId = this.Id
   
     this.collectionId = this.props.Id 
     this.$nextTick(() => {
            this.getData()      
            })
      
  },


  methods: 
  {
    async getData()
    {
      
      const sp   = {'sp'        : 'spCollections'}            
      this.spinner = true
      await api.post(sp).then(res => {
          if(res.status==200)
            {
             
              this.items        = res.data.recordsets[0]      
              //this.collectionId = this.props.Id           
            }
           else if(res.status==500)
           {
                console.log(res.data)
                                    
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });



    },
  
    
    
  
}

}
</script>
<style scoped>

</style>